import classNames from "classnames";
import "./index.scss";

type Props = {
  icon: string;
  onClick?: (event?: any) => void;
  size?: "small" | "medium" | "large" | "x-large";
  hoverTitle?: string | null;
  type?: "success" | "primary";
};

const CustomIcons = ({
  icon,
  onClick,
  size = "medium",
  hoverTitle,
  type,
}: Props) => {
  return (
    <section
      id="custom-icon-container"
      className={type ? `custom-icon-${type}` : ""}
      onClick={onClick}
    >
      {hoverTitle && (
        <div className="tooltip-hover">
          <span>{hoverTitle}</span>
          <div className="after-arrow"></div>
        </div>
      )}
      <i className={classNames(icon, ` ${size}`, "icon")}></i>
    </section>
  );
};

export default CustomIcons;
